import { Injectable } from '@angular/core';
import { UserClient, SettingResponse, CompanyClient } from './api.service';
import { Observable, combineLatest, Subject, of, Subscription } from 'rxjs';
import { map, tap, startWith } from 'rxjs/operators';
import { SettingsClient } from '../clients/settingsClient';
@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  private settingsSubject: Subject<Array<SettingResponse>>;
  private allSettings: SettingResponse[];
  private settings$: Subscription ;

  constructor(
    private userClient: UserClient,
    private companyClient: CompanyClient,private _settingsClient:SettingsClient
  ) {
    this.settingsSubject = new Subject<Array<SettingResponse>>();
  }

  private loadSettings() {
    const userSettings = this.userClient.getSettings();
    const companySettings = this.companyClient.getSettingsAll();

    this.settings$ = combineLatest([userSettings, companySettings])
      .pipe(
        map(([uSettings, cSettings]) => {
          return [...uSettings, ...cSettings];
        }),
        tap(result => {
          this.allSettings = result;
          this.settingsSubject.next(result);
          this.settings$.unsubscribe();
          //this.settings$ = undefined;
        })
      )
      .subscribe();
  }

  // This gets all settings even tho it says users
  get getUserSettings(): Observable<SettingResponse[]> {
    let currentSetting = this.defaultSettings();
    if (this.allSettings !== undefined) 
     
      currentSetting = this.allSettings;
    

    if (this.allSettings === undefined && this.settings$ === undefined) 
      
      this.loadSettings();
    

    return this.settingsSubject.asObservable().pipe(startWith(currentSetting));
  }

  clearSettings() {
    this.allSettings = new Array<SettingResponse>();
  }

  private replaceSetting(setting: SettingResponse) {
    for (let i = 0; i < this.allSettings.length; i++) {
      if (this.allSettings[i].settingKey === setting.settingKey) {
        this.allSettings[i] = setting;
      }
    }
  }

  private defaultSettings(): Array<SettingResponse> {
    const settings = new Array<SettingResponse>();
    settings.push(
      new SettingResponse({
        settingKey: 0,
        settingName: 'ColumnLayout',
        settingValue: JSON.stringify([
          { name: 'lastname', label: 'Surname' },
          { name: 'firstname', label: 'Given Names' },
          { name: 'referringDoctor', label: 'Referred By' },
          { name: 'scanType', label: 'Referred For' },
          { name: 'preferredBooking', label: 'Preferred Time' },
          { name: 'source', label: 'Source Type' },
          { name: 'createdDate', label: 'Date Received' },
          { name: 'reminderDate', label: 'Reminder' },
          { name: 'attachmentCount', label: 'Attachment' },
          { name: 'smsSent', label: 'SMS' },
          { name: 'status', label: 'Status' }
        ])
      })
    );
    settings.push(
      new SettingResponse({
        settingKey: 0,
        settingName: 'EnableAddBooking',
        settingValue: 'false'
      })
    );
    settings.push(
      new SettingResponse({
        settingKey: 0,
        settingName: 'ListAgeFilters',
        settingValue: JSON.stringify([
          {
            label: 'All',
            startTime: '',
            timeSpan: ''
          },
          {
            label: '1-2hours',
            startTime: '00:00:01.0',
            timeSpan: '00:00:01.0'
          },
          {
            label: '2-4hours',
            startTime: '00:00:02.0',
            timeSpan: '00:00:04.0'
          },
          {
            label: '4-12hours',
            startTime: '00:00:04.0',
            timeSpan: '00:00:08.0'
          },
          {
            label: '24+hours',
            startTime: '00:00:24.0',
            timeSpan: '00:00:00.0'
          }
        ])
      })
    );
    return settings;
  }

  updateSetting(id: number, val: string) {
    this.userClient.updateSetting(id, val).subscribe(setting => {
      this.replaceSetting(setting);
    });
  }
  getPositions()
  {
    return this._settingsClient.getPositions();
  }
  getRoles()
  {
    return this._settingsClient.getRoles();
  }
  getTitles()
  {
    return this._settingsClient.getTitles();
  }
}
